<template>
  <hr :class="classes || 'border-grey-700 h-px w-full my-4'" />
</template>

<script>
export default {
  name: 'Separator',
  props: ['value', 'classes'],
};
</script>